import MapaTurismo from "./Mapa";

function EventosAnteriores() {

	return (
		<>
	<MapaTurismo />
		</>
	)

} 

export default EventosAnteriores;